import { Controller } from "@hotwired/stimulus";

// data-controller="step-dropdown"
export default class extends Controller {
  static targets = ["button"];

  showLoading(event) {
    const link = event.currentTarget;
    const stepName = link.dataset.stepName;

    // Atualiza o texto do botão principal
    this.buttonTarget.innerHTML = `<span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span> ${stepName}`;
    this.buttonTarget.classList.add("disabled");

    // Fecha o dropdown
    const dropdown = document.querySelector("#step-dropdown-menu");
    if (dropdown) dropdown.classList.remove("show");
  }
}
